<template>
  <div class="pd-VendorVideo_OuterWrapper">
    <div v-if="visible" class="pd-VendorVideo_Wrapper">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "StoreVendorIntro_Video",
  computed: {
    ...mapGetters({
      showVendorIntroVideo: "productShow/showVendorIntroVideo",
    }),
    visible() {
      return this.showVendorIntroVideo;
    },
  },
};
</script>

<style scoped>
.pd-VendorVideo_Wrapper {
  position: relative;
  padding-bottom: 56.25%; /* Default for 1600x900 videos 16:9 ratio */
  padding-top: 0;
  height: 0;
  overflow: hidden;
}

.pd-VendorVideo_Wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
